import groq from 'groq'
import { imageAsset } from '../../imageAsset'

export const problem = groq`
 _type,
  topNote,
  title,
  image {...${imageAsset()}},
  description,
  pointsLabel,
  points
`
